var _circle, _circle2, _g, _g2, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddpayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_229",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#ECEDEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_229)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_229)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 30,
    width: 96,
    height: 95,
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_229)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 96,
    height: 22,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 30,
    width: 96,
    height: 33,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 88,
    width: 24,
    height: 4,
    fill: "#ECEDEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 88,
    width: 13,
    height: 4,
    fill: "#ECEDEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 88,
    width: 9,
    height: 4,
    fill: "#ECEDEE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 96,
    width: 16,
    height: 4,
    fill: "#ECEDEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.5003 33H34.5003C32.383 33 30.667 34.716 30.667 36.8333V69.1667C30.667 71.284 32.383 73 34.5003 73H85.5003C87.6177 73 89.3337 71.284 89.3337 69.1667V36.8333C89.3337 34.716 87.6177 33 85.5003 33Z",
    fill: "#008B6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3337 39.6667H30.667V45H89.3337V39.6667Z",
    fill: "#1A1B1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0003 53H36.0003C35.2643 53 34.667 52.4027 34.667 51.6667V49C34.667 48.264 35.2643 47.6667 36.0003 47.6667H84.0003C84.7363 47.6667 85.3337 48.264 85.3337 49V51.6667C85.3337 52.4027 84.7363 53 84.0003 53Z",
    fill: "#E0F5F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85 80C91.0751 80 96 75.0751 96 69C96 62.9249 91.0751 58 85 58C78.9249 58 74 62.9249 74 69C74 75.0751 78.9249 80 85 80Z",
    fill: "#FFD43E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_229",
    x: 5,
    y: 25,
    width: 110,
    height: 109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_229"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_229",
    x: 5,
    y: 3,
    width: 110,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_229"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_229",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddpayment);
export default __webpack_public_path__ + "static/media/addpayment.e38a26211b79656e4029d6958a8c5db3.svg";
export { ForwardRef as ReactComponent };